/* CRO - upsell nel cart drawer (Present Mushrooms)
   Caricato una volta da cart-drawer.liquid: gli handler sono delegati sul document,
   quindi continuano a funzionare anche dopo i re-render del drawer.

   Bundle Focus & Energia: quando in carrello c'è una coppia complementare
   (Lion's polvere + Cordyceps gocce, oppure Cordyceps polvere + Lion's gocce)
   applica il codice sconto indicato in [data-bundle-state] (-10% sul carrello)
   e lo rimuove quando la coppia viene spezzata. Lo stato (coppia presente /
   codice applicato) è calcolato in Liquid da snippets/cart-upsells.liquid. */
(function () {
  if (window.__pmCartUpsellsInit) return;
  window.__pmCartUpsellsInit = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function rerender(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      drawer.renderContents(state);
    } else {
      window.location.reload();
    }
  }

  function addVariant(id) {
    return postJSON(root() + 'cart/add.js', {
      items: [{ id: Number(id), quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    });
  }

  /* Codici sconto attualmente agganciati al carrello (anche se non applicabili) */
  function cartCodes() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
      });
  }

  /* Aggiunge o toglie il codice bundle lasciando intatti gli altri codici; restituisce le sezioni aggiornate */
  function setBundleCode(code, on) {
    return cartCodes().then(function (codes) {
      var others = codes.filter(function (c) { return c !== code; });
      var next = on ? others.concat([code]) : others;
      codeAttached = on;
      return postJSON(root() + 'cart/update.js', {
        discount: next.join(','),
        sections: SECTIONS,
        sections_url: window.location.pathname
      });
    });
  }

  /* ---- Sincronizzazione codice bundle ---- */
  var syncing = false;
  var lastSync = '';
  var codeAttached = null; /* null = non ancora verificato */

  function bundleState() {
    var el = document.querySelector('cart-drawer [data-bundle-state]');
    if (!el) return null;
    return {
      code: el.getAttribute('data-bundle-code') || '',
      pair: el.getAttribute('data-bundle-pair') === 'true',
      applied: el.getAttribute('data-bundle-applied') === 'true'
    };
  }

  function syncBundleCode() {
    if (syncing) return;
    var s = bundleState();
    if (!s || !s.code) return;
    var action = null;
    if (s.pair && !s.applied) action = 'apply';
    /* coppia spezzata: il codice resta agganciato (non applicabile) e va tolto,
       altrimenti tornerebbe attivo aggiungendo un secondo prodotto qualsiasi */
    if (!s.pair && (s.applied || codeAttached !== false)) action = 'remove';
    if (!action) { lastSync = ''; return; }
    var sig = action + ':' + s.code;
    if (sig === lastSync) return; /* evita loop se Shopify rifiuta il codice */
    lastSync = sig;
    syncing = true;
    var p;
    if (action === 'remove' && !s.applied) {
      /* verifica prima se il codice è davvero agganciato: evita richieste inutili */
      p = cartCodes().then(function (codes) {
        if (codes.indexOf(s.code) === -1) { codeAttached = false; return null; }
        return setBundleCode(s.code, false);
      });
    } else {
      p = setBundleCode(s.code, action === 'apply');
    }
    p.then(function (state) { syncing = false; if (state) rerender(state); })
      .catch(function () { syncing = false; });
  }

  /* Osserva i re-render del drawer (add to cart, cambio quantità, rimozione) */
  var observed = null;
  var timer = null;
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer === observed) return;
    observed = drawer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(syncBundleCode, 150);
    }).observe(drawer, { childList: true, subtree: true });
    syncBundleCode();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }

  /* ---- Click sui bottoni upsell ---- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-cart-upsell-add]');
    var swap = e.target.closest('[data-cart-swap]');
    if (!add && !swap) return;
    e.preventDefault();
    var btn = add || swap;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    var chain;
    if (swap) {
      var updates = {};
      updates[swap.getAttribute('data-cart-swap-remove')] = 0;
      chain = postJSON(root() + 'cart/update.js', { updates: updates }).then(function () {
        return addVariant(swap.getAttribute('data-cart-swap'));
      });
    } else {
      /* aggiunge il complementare e applica subito il codice bundle */
      var s = bundleState();
      chain = addVariant(add.getAttribute('data-cart-upsell-add')).then(function (state) {
        if (s && s.code) return setBundleCode(s.code, true);
        return state;
      });
    }

    chain.then(rerender).catch(function () { window.location.reload(); });
  });
})();
